// @flow
import React, { Component, Fragment } from 'react'
import type { Configs, OptionType } from '../types'
import LabeledWrapper from './LabeledWrapper'
import { InputCell } from '../AudienceEdit'
import FormContainer from '../leadforms/FormContainer'
import styled from 'styled-components'
import SelectControl from '../controls/Select'
import type { SocialPublicProps } from '../../redux/ducks/audienceEdit/reducers'
import { grayColor, linkColor } from '../controls/colors'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

const SelectCell = styled.div`
  flex: 100%;
`

const Delimeter = styled.div`
  padding-left: 16px;
  padding-right: 16px;
`

const Link = styled.a`
  font-size: 14px;
  border-bottom: 1px dashed #61b8d3;
  color: ${({ isDisabled }) => (isDisabled ? grayColor : linkColor)};
  text-decoration: blink;
  border-color: ${({ isDisabled }) => (isDisabled ? grayColor : linkColor)};
`

const t = {
  label: 'Лид-форма',
  select: 'Выберите лид-форму',
  placeholder: 'Выберите...',
  create: 'создайте',
  no_results: 'Ничего не найдено',
  or: 'или'
}

export type Props = {|
  isDisabled: boolean,
  errors: Array<string>,
  leadformId: number | null,
  configs: Configs,
  socialPublicProps: SocialPublicProps,
  adAccountId: number,
  options: Array<OptionType>,
  onLeadformIdChange: (number) => void,
  onCreate: () => void
|}

export default class LeadformSelect extends Component<Props> {
  render() {
    return (
      <Fragment>
        <h2>{t.select}</h2>

        <LabeledWrapper label={t.label} errors={this.props.errors}>
          <InputCell>
            <Wrapper>
              <SelectCell className="t-LeadformSelect">
                <SelectControl
                  value={this.props.leadformId}
                  options={this.props.options}
                  onChange={(id) => this.props.onLeadformIdChange(id)}
                  placeholder={t.placeholder}
                  noResultsText={t.no_results}
                  disabled={this.props.isDisabled}
                />
              </SelectCell>
              <Delimeter>{t.or}</Delimeter>
              <div>
                <Link
                  isDisabled={this.props.isDisabled}
                  onClick={(e) => {
                    e.preventDefault()
                    if (this.props.isDisabled) return
                    this.props.onCreate()
                  }}
                  href="#"
                >
                  {t.create}
                </Link>
                <FormContainer
                  configs={this.props.configs}
                  isOrtAccounts
                  socialPublicProps={this.props.socialPublicProps}
                  adAccountId={this.props.adAccountId}
                />
              </div>
            </Wrapper>
          </InputCell>
        </LabeledWrapper>
      </Fragment>
    )
  }
}
